import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { NavItem, NavLine } from '../styled';


var noop = function noop() {};

var TabItem = function (_Component) {
  _inherits(TabItem, _Component);

  function TabItem() {
    _classCallCheck(this, TabItem);

    return _possibleConstructorReturn(this, (TabItem.__proto__ || _Object$getPrototypeOf(TabItem)).apply(this, arguments));
  }

  _createClass(TabItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          elementProps = _props.elementProps,
          innerRef = _props.innerRef,
          isSelected = _props.isSelected;

      return React.createElement(
        NavItem,
        _extends({}, elementProps, {
          innerRef: innerRef,
          status: isSelected ? 'selected' : 'normal'
        }),
        data.label,
        isSelected ? React.createElement(NavLine, { status: 'selected' }) : null
      );
    }
  }]);

  return TabItem;
}(Component);

TabItem.defaultProps = {
  data: {},
  elementProps: {},
  innerRef: noop,
  isSelected: false
};
export default TabItem;